<template>
    <section
        id="pif-xgspon-infos"
        class="border border-light py-1 px-1 mb-2 alert-fix"
    >
        <h4 class="h4 h4-fix mb-0">
            {{ pifXgsponInfos.title }}
        </h4>
        <p data-writefontsize="" class="p-0 text-mw">
            <strong>
                {{ pifXgsponInfos.content }}
            </strong>
        </p>
        <a
            :href="pifXgsponInfos.url"
            class="btn btn-secondary pif-infos--collapse"
            :data-oevent-category="pifXgsponInfos.buttonTms.category"
            :data-oevent-action="pifXgsponInfos.buttonTms.action"
            :data-oevent-label="pifXgsponInfos.buttonTms.label"
        >
            {{ pifXgsponInfos.buttonLabel }}
        </a>
    </section>
</template>

<script>
export default {
    name: "PifXgsponInfos",
    props: {
        pifXgsponInfos: {
            type: Object, required: true
        }
    },
    data() {
        return {}
    },
    methods: {}
}
</script>

<style scoped>

</style>
